




































import Vue from 'vue';

import * as ping from '@/lib/usage_ping';

import navdots from '@/components/nav-dots.vue';
import skipbtn from '@/views/app/welcome/skip.vue';
import trialbtn from '@/components/btn-freetrial.vue';

export default Vue.extend({
    components: {
        'nav-dots': navdots,
        'skip-btn': skipbtn,
        'trial-btn': trialbtn,
    },
    methods: {
        updateOption(option) {
            this.selectedOption = option;
            this.$emit('updateOption', this.selectedOption);
        },
        navSelected(payload) {
            this.$router.push(payload.path);
        },
        basic() {
            ping.send({ type: ping.SubscriptionUsage.reject, uid: this.currentUser.uid});
            this.$router.push('/app');
        }
    },
    computed: {
        myNavOptions() {
            return this.getOnboardingItems(window.location.pathname);
        }
    }
})
